import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import storeReducer from './storeReducer';

/** Persist redux state on refresh */
import { persistStore } from 'redux-persist';

// remove redux tool in production environment
import { IsProduction } from './../utility/environment_config';

let _compose = IsProduction ?
    applyMiddleware(thunk) : compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export const store = createStore(
    storeReducer,
    _compose
)

export const persistedState = persistStore(store)
export default { store, persistedState };